import { render, staticRenderFns } from "./ManageInvites.vue?vue&type=template&id=5c54738f"
import script from "./ManageInvites.vue?vue&type=script&lang=js"
export * from "./ManageInvites.vue?vue&type=script&lang=js"
import style0 from "./ManageInvites.vue?vue&type=style&index=0&id=5c54738f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports